import { Validators } from '@angular/forms';

import { ComponentTypesEnum } from '../../../app/shared/enums';
import { DialogButtonTypesEnum, DialogConfigInterface } from '../../../app/shared/components';
import {AmountControl, BaseControl, Helper, SelectControl} from '../../../app/shared/classes';

import { AccountSubTypeEnum } from '@spa/api';

export const FundOrderBuyAmountSelector = 'fundOrderBuyAmount';
export const FundOrderBuyProductSelector = 'fundOrderBuyProducts';

export interface FundOrderBuyControlsInterface {
    amount: AmountControl;
    product: SelectControl;
}

export const GetFundOrderBuyPurchaseDateText = (date: string): string => {
    return `Product PURCHASE price for ${Helper.formatDate(date)}`;
};

export const GetFundOrderBuyAmountPlaceholderText = (accountSubType: AccountSubTypeEnum): string => {
    switch (accountSubType) {
        case AccountSubTypeEnum.MutualFund:
            return 'Amount';
        case AccountSubTypeEnum.InstrumentCertificate:
            return 'Face Value';
        default:
            return '';
    }
};

export const FundOrderBuyComponentControls = (): FundOrderBuyControlsInterface => {
    return {
        product: new SelectControl({
            name: FundOrderBuyProductSelector,
            value: null,
            placeholder: 'Product Name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        amount: new AmountControl({
            name: FundOrderBuyAmountSelector,
            value: null,
            placeholder: 'Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        })
    };
};

export const FundOrderBuyDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
